import {Component} from '@angular/core';
import {ViewController, NavParams} from 'ionic-angular';
import {EquipmentType} from '../../../../../services/equipmenttype.service';

@Component({
    template: `
        <ion-list>
            <ion-list-header color="dark">Equipment</ion-list-header>
            <button ion-button full color="light" *ngFor="let x of equiptypeList" (click)="selectItem(x)">{{x.name}}</button>
        </ion-list>
    `,
})
export class EquipmentPopover {

    // Declare our preset title list
    private equiptypeList : EquipmentType[];

    constructor( 
        public viewCtrl : ViewController,
    ) {
        // Assign our title list to our preset list
        let navParams : NavParams = this.viewCtrl.getNavParams();
        this.equiptypeList = navParams.get("equiptype");
    }
    
    selectItem(item : EquipmentType) {
        this.viewCtrl.dismiss({
            selected: item
        });
    }
}
    


// WEBPACK FOOTER //
// ./src/pages/report/tab-main/equipment/equipment-popover/equipment-popover.component.ts